export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/sparse.js
// module id = 39
// module chunks = 0